import { connect } from 'react-redux';
import { getInspectionCommentListBegin, getInspectionDetailsBegin } from '../../store/actions/inspection.actions';
import {
    getInspectionDetail,
    getInspectionDetailLoading,
    getInspectionEditForm,
    getInspectionCommentList,
    getViolationListAssociatedWithInspection,
    getLoadMoreViolationAssociatedToInspection,
    getLoadMoreInspectionCommentList,
    getInspectionViolationsLoadingStatus,
} from '../../store/selectors/inspection.selectors';
import { getApplicationDetailBegin, setActiveTab } from '../../store/actions/license.actions';
import {
    addInspectionCommentBegin,
    getViolationListAssociatedWithInspectionBegin,
    deleteViolationAssociatedWithInspectionBegin,
    addViolationAssociatedWithInspectionBegin,
} from '../../store/actions/inspection.actions';
import InspectionDetailTabs from './InspectionDetailTabs';
import { getApplicationDetail } from '../../store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const isLoading = getInspectionDetailLoading(state);
    const editForm = getInspectionEditForm(state);
    const inspectionDetail = getInspectionDetail(state);
    const inspectionCommentList = getInspectionCommentList(state);
    const inspectionViolations = getViolationListAssociatedWithInspection(state);
    const hasMoreViolationAssociatedToInspection = getLoadMoreViolationAssociatedToInspection(state);
    const hasMoreInspectionComments = getLoadMoreInspectionCommentList(state);
    const inspectionViolationsLoading = getInspectionViolationsLoadingStatus(state);
    const application = getApplicationDetail(state);

    return {
        isLoading,
        editForm,
        application,
        inspectionDetail,
        inspectionCommentList,
        inspectionViolations,
        hasMoreViolationAssociatedToInspection,
        hasMoreInspectionComments,
        inspectionViolationsLoading,
    };
};

const mapDispatchToProps = {
    getInspectionDetails: getInspectionDetailsBegin,
    setActiveTab: setActiveTab,
    addInspectionComment: addInspectionCommentBegin,
    getInspectionCommentsList: getInspectionCommentListBegin,
    getApplication: getApplicationDetailBegin,
    getInspectionViolations: getViolationListAssociatedWithInspectionBegin,
    deleteViolation: deleteViolationAssociatedWithInspectionBegin,
    addViolation: addViolationAssociatedWithInspectionBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(InspectionDetailTabs);
